import axios from 'axios';
const API_URL = process.env.REACT_APP_PLATFORM_API_URL;

const api = axios.create({
  baseURL: API_URL,
  withCredentials: false,
});

export default api;
